define('plugins/musicfavourite/nls/sounds/button',{
    'en-gb': {
        'standard': {
            'addToFavourites'       : 'Subscribe',
            'adding'                : 'Subscribing',
            'addedToFavourites'     : 'Subscribed',
            'removeFromFavourites'  : 'Unsubscribe',
            'removeFromFavouritesFullText' : 'Unsubscribe',
            'removing'              : 'Unsubscribing'
        },
        'medium': {
            'addToFavourites'       : 'Subscribe',
            'adding'                : 'Subscribing',
            'addedToFavourites'     : 'Subscribed',
            'removeFromFavourites'  : 'Unsubscribe',
            'removing'              : 'Unsubscribing'
        }
    },
    'cy-gb': { //WELSH
        'standard': {
            'addToFavourites'       : 'Tanysgrifio',
            'adding'                : 'Yn tanysgrifio',
            'addedToFavourites'     : 'Wedi tanysgrifio',
            'removeFromFavourites'  : 'Dad-danysgrifio',
            'removeFromFavouritesFullText' : 'Dad-danysgrifio',
            'removing'              : 'Yn dad-danysgrifio'
        },
        'medium': {
            'addToFavourites'       : 'Tanysgrifio',
            'adding'                : 'Yn tanysgrifio',
            'addedToFavourites'     : 'Wedi tanysgrifio',
            'removeFromFavourites'  : 'Dad-danysgrifio',
            'removing'              : 'Yn dad-danysgrifio'
        }
    },
    'ga-gb': { //IRISH
        'standard': {
            'addToFavourites'       : 'Cl&aacute;raigh',
            'adding'                : 'Ag cl&aacute;r&uacute;',
            'addedToFavourites'     : 'Cl&aacute;raithe',
            'removeFromFavourites'  : 'D&iacute;chl&aacute;raigh',
            'removeFromFavouritesFullText' : 'D&iacute;chl&aacute;raigh',
            'removing'              : 'Ag d&iacute;chl&aacute;r&uacute;'
        },
        'medium': {
            'addToFavourites'       : 'Cl&aacute;raigh',
            'adding'                : 'Ag cl&aacute;r&uacute;',
            'addedToFavourites'     : 'Cl&aacute;raithe',
            'removeFromFavourites'  : 'D&iacute;chl&aacute;raigh',
            'removing'              : 'Ag d&iacute;chl&aacute;r&uacute;'
        }
    },
    'gd-gb': { //SCOTTISH
        'standard': {
            'addToFavourites'       : 'Fo-sgr&igrave;obh',
            'adding'                : 'A\' fo-sgr&igrave;obhadh',
            'addedToFavourites'     : 'Air fo-sgr&igrave;obhadh',
            'removeFromFavourites'  : 'Stad a\' fo-sgr&igrave;obhadh',
            'removeFromFavouritesFullText' : 'Stad a\' fo-sgr&igrave;obhadh',
            'removing'              : 'A\' cur stad air fo-sgr&igrave;obhadh'
        },
        'medium': {
            'addToFavourites'       : 'Fo-sgr&igrave;obh',
            'adding'                : 'A\' fo-sgr&igrave;obhadh',
            'addedToFavourites'     : 'Air fo-sgr&igrave;obhadh',
            'removeFromFavourites'  : 'Stad a\' fo-sgr&igrave;obhadh',
            'removing'              : 'A\' cur stad air fo-sgr&igrave;obhadh'
        }
    }
});

